'use client';

import { MAX_NUMBER_OF_PERP_POSITIONS } from 'src/constants/constants';
import { MarketType } from '@drift-labs/sdk';
import { ENUM_UTILS } from '@drift/common';
import { useMemo } from 'react';
import { useCurrentAccountPositions } from './query/accountTradingData/usePositions';
import { useCurrentAccountOrders } from './query/accountTradingData/useOrders';

const useUserWillExceedMaxPerpsPositions = (
	marketIndexToAddPositionTo: number | undefined
) => {
	const userOpenPerpPositions = useCurrentAccountPositions();
	const userOpenOrders = useCurrentAccountOrders();

	// Get all market indices from open positions (both active and inactive positions with unsettled pnl)
	const openPositionMarketIndices = useMemo(
		() => userOpenPerpPositions.map((position) => position.marketIndex),
		[userOpenPerpPositions]
	);

	// Get market indices from open orders
	const openOrderMarketIndices = useMemo(
		() =>
			userOpenOrders
				.filter((order) => ENUM_UTILS.match(order.marketType, MarketType.PERP))
				.map((order) => order.marketIndex),
		[userOpenOrders]
	);

	// If user already has position/order/unsettledPnl in this market, they won't exceed max
	if (
		marketIndexToAddPositionTo === undefined ||
		openPositionMarketIndices.includes(marketIndexToAddPositionTo) ||
		openOrderMarketIndices.includes(marketIndexToAddPositionTo)
	) {
		return false;
	}

	// Combine all market indices and dedupe
	const uniqueMarketIndices = new Set([
		...openPositionMarketIndices,
		...openOrderMarketIndices,
	]);

	// Add the new position's market index
	uniqueMarketIndices.add(marketIndexToAddPositionTo);

	return uniqueMarketIndices.size > MAX_NUMBER_OF_PERP_POSITIONS;
};

export default useUserWillExceedMaxPerpsPositions;
